import * as React from 'react';
import BaggageDialogHeader, {
	Props
} from '@websky/core/src/Baggage/UpgradeBaggageDialog/components/BaggageDialogHeader/BaggageDialogHeader';

const OverriddenBaggageDialogHeader: React.FC<Props> = props => {
	return <BaggageDialogHeader {...props} switchVariant={'secondary'} />;
};

export default OverriddenBaggageDialogHeader;
